import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { get, isEqual } from 'lodash'
import NavBar from 'components/NavBar'
import { apiFetch } from 'helpers'
import { FormGroup, Label, Input, Button, Select, ErrorText } from 'components/Form'

@connect(state => ({
  me: get(state, 'vendor.me'),
  saving: get(state, 'vendor.saveVendorAttempting')
}))
export default class extends Component {
  constructor (props) {
    super(props)
    this.state = this._getVendorState(props)
  }

  _getVendorState = (props) => ({
    categoryId: get(props, 'me.category._id'),
    categoryName: get(props, 'me.category.nameTh'),
    nameTh: get(props, 'me.nameTh'),
    nameEn: get(props, 'me.nameEn'),
    contactNumber: get(props, 'me.contactNumber'),
    lineId: get(props, 'me.lineId'),
    website: get(props, 'me.website'),
    facebookPage: get(props, 'me.facebookPage'),
    instagram: get(props, 'me.instagram')
  })

  componentWillReceiveProps (nextProps) {
    if (!isEqual(this.props.me, nextProps.me)) {
      this.setState(this._getVendorState(nextProps))
    }
  }

  _onSave = () => {
    let errors = {
      nameThError: this.state.nameTh ? '' : 'จำเป็นต้องกรอกข้อมูล',
      nameEnError: this.state.nameEn ? '' : 'จำเป็นต้องกรอกข้อมูล',
      contactNumberError: this.state.contactNumber ? '' : 'จำเป็นต้องกรอกข้อมูล'
    }
    if (Object.keys(errors).some(key => errors[key])) {
      this.props.dispatch({ type: 'SEND_MESSAGE', messageType: 'error', message: 'กรอกข้อมูลไม่ครบถ้วน, กรุณาตรวจสอบอีกครั้ง' })
      return this.setState(errors)
    }

    this.setState({ errors }, () => apiFetch({
      dispatch: this.props.dispatch,
      key: 'SAVE_VENDOR',
      method: 'PUT',
      v4: true,
      url: '/v4/vendors/me',
      body: {
        category: this.state.categoryId,
        nameTh: this.state.nameTh,
        nameEn: this.state.nameEn,
        contactNumber: this.state.contactNumber,
        lineId: this.state.lineId,
        website: this.state.website,
        facebookPage: this.state.facebookPage,
        instagram: this.state.instagram
      }
    })
      .then(() => {
        this.props.dispatch({ type: 'SEND_MESSAGE', messageType: 'success', message: 'บันทึกข้อมูลทั่วไปสำเร็จ' })
        this.props.history.replace('/settings')
      })
      .catch(() => this.props.dispatch({ type: 'SEND_MESSAGE', messageType: 'error', message: 'บันทึกข้อมูลทั่วไปไม่สำเร็จ, กรุณาลองใหม่อีกครั้ง' }))
    )
  }

  render () {
    const { history, saving } = this.props
    return (
      <section>
        <NavBar onBack={() => history.replace('/settings')} backTitle='ตั้งค่า' title='ข้อมูลทั่วไป' />
        <Body>
          <FormGroup>
            <Label required>หมวดร้านค้า</Label>
            <Select title={this.state.categoryName} />
          </FormGroup>
          <FormGroup>
            <Label required>ชื่อร้านค้า (ไทย)</Label>
            {this.state.nameThError && <ErrorText>{this.state.nameThError}</ErrorText>}
            <Input type='text' value={this.state.nameTh}
              onChange={e => this.setState({ nameTh: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label required>ชื่อร้านค้า (อังกฤษ)</Label>
            {this.state.nameEnError && <ErrorText>{this.state.nameEnError}</ErrorText>}
            <Input type='text' value={this.state.nameEn}
              onChange={e => this.setState({ nameEn: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label required>เบอร์โทรติดต่อร้าน</Label>
            {this.state.contactNumberError && <ErrorText>{this.state.contactNumberError}</ErrorText>}
            <Input type='text' value={this.state.contactNumber}
              onChange={e => this.setState({ contactNumber: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Line ID ของร้าน</Label>
            <Input type='text' value={this.state.lineId}
              onChange={e => this.setState({ lineId: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Website</Label>
            <Input type='text' value={this.state.website}
              onChange={e => this.setState({ website: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Facebook</Label>
            <Input type='text' value={this.state.facebookPage}
              onChange={e => this.setState({ facebookPage: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Instagram</Label>
            <Input type='text' value={this.state.instagram}
              onChange={e => this.setState({ instagram: e.target.value })} />
          </FormGroup>
          <Button style={{ marginTop: 30 }} loading={saving} onClick={this._onSave}>บันทึก</Button>
        </Body>
      </section>
    )
  }
}

const Body = styled.section`
  padding: 15px;
`



// WEBPACK FOOTER //
// ./src/containers/EditInfo.js